import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import {
  LAST_SELECTED_PROFILE_ID_STORAGE_KEY,
  StoredProfileHelper
} from 'src/utils/location_storage/location_storage'
import { removeItem } from 'src/utils/storage_wrapper/storage_wrapper'

export interface IAuthContext {
  selectedProfileId: string | null;
  setSelectedProfileId: (value: string | null) => void;
}

const AuthContext = createContext<IAuthContext | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [selectedProfileId, _setSelectedProfileId] = useState<string | null>(
    null
  )

  const setSelectedProfileId = useCallback((value: string | null) => {
    _setSelectedProfileId(value)
    if (value !== null) {
      StoredProfileHelper.storeCurrentProfileId(value)
    } else {
      removeItem(LAST_SELECTED_PROFILE_ID_STORAGE_KEY)
    }
  }, [])

  const value = useMemo(
    () => ({ selectedProfileId, setSelectedProfileId }),
    [selectedProfileId, setSelectedProfileId]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuthContext (): IAuthContext {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  return ctx
}

export default AuthContext
